export default __webpack_public_path__ + "static/media/svgIcons.sprite.13165937.svg";